import Glide from '@glidejs/glide';
import gsap from 'gsap/all';

const initSliders = function() {
  const sliders = document.querySelectorAll('.slider .glide');

  sliders.forEach((slider) => {
    // prevent subsequent initialization of a slider
    if (slider.getAttribute('data-slider-inited')) {
      return;
    }

    if(slider.parentElement.classList.contains('slider__pageIntro') && slider.parentElement.classList.contains('slider--count-1')) {
      const slide = slider.querySelector('.glide__slide');
      initAnimation(slide);
      return;
    }

    slider.setAttribute('data-slider-inited', 'true');

    slider.i = window.i;
    const config = {};

    try {
      const sliderConfig = JSON.parse(slider.getAttribute('config'));
      Object.assign(config, sliderConfig);
    } catch (e) {
    }

    const activeBullet = 'glide__bullet--active';
    const activeSlideCounter = slider.querySelector('.glide__counter');
    const bulletsContainerElement = slider.querySelector('.glide__bullets');
    const slides = slider.querySelectorAll('.glide__slide');

    const changeActiveBullet = (newIndex, containerElement) => {
      const glideDir = containerElement.querySelector(
        `[data-glide-dir="=${newIndex}"]`,
      );

      containerElement.querySelector(`.${activeBullet}`).classList.remove(activeBullet);

      if (glideDir) {
        glideDir.classList.add(activeBullet);
        if (activeSlideCounter) {
          activeSlideCounter.innerHTML =
            parseInt(
              glideDir.getAttribute('data-glide-dir').replace(/=/g, ''),
            ) + 1;
        }
      }
    };

    const defaultConfig = {
      type: 'carousel',
      animationDuration: 1000,
    };

    const glide = new Glide(slider, {
      ...defaultConfig,
      ...config,
    }).mount();

    if (slides.length === 1) {
      glide.disable();

      slides.forEach((slide) => {
        slide.classList.remove('select-none', 'cursor-grab');
      });
    }

    if (config.autoHeight) {
      glide.on(['mount.after', 'run', 'resize', 'move.after'], () => {
        const {Html} = glide._c;
        const {track} = Html;
        const slide = Html.slides[glide.index];
        track.style.height = `${slide.offsetHeight}px`;
      });
    }

    glide.on('run', () => {
      requestAnimationFrame(() =>
        changeActiveBullet(glide.index, bulletsContainerElement),
      );
    });

    glide.on('run.before', () => {
      let slides = gsap.utils.toArray('.glide__slides');
      slides = slides.filter(slide => !slide.classList.contains('corporate-news-glide__slides'));
      let tl = new gsap.timeline();

      tl.to(slides, {xPercent: -100, ease: 'none'});
    });
    if (slider.parentElement.classList.contains('slider__pageIntro')) {
      const slide = slider.querySelector('.glide__slide--active');
      initAnimation(slide);

      if (window.innerWidth >= 768) {
        glide.on(['build.after', 'run.after'], () => {
          const slide = slider.querySelector('.glide__slide--active');
            if (slide) initAnimation(slide);
        });
      }

      window.addEventListener('initSliders', initSliders);
    }

    // destroy glide and revert slider to original form before page is replaced by swup
    const unload = () => {
      slider.setAttribute('data-slider-inited', null);
      glide.destroy();
      document.removeEventListener('swup:willReplaceContent', unload);
    };

    document.addEventListener('swup:willReplaceContent', unload);
  });
};

const initAnimation = function(slide) {
  const inBackend = document.body.classList.contains('neos-backend');

  if (inBackend) return;

  const pageIntro = slide.querySelector(
    '.should-animate',
  );

  const backgroundImage = pageIntro.querySelector('.image-background');
  const circles = pageIntro.querySelector('.triple-half-moon');
  const content = pageIntro.querySelector('.content');

  if (!circles) return;

  const gradientCircles = circles.querySelectorAll(
    '.gradient, .first, .second, .third',
  );

  const gsapSet = [gradientCircles];

  if (backgroundImage) gsapSet.unshift(backgroundImage);

  gsap.set(content, {
    opacity: 0,
  });

  gsap.set(gsapSet, {
    xPercent: -100,
  });

  let tl = gsap.timeline().to('.should-animate', {
    opacity: 1,
  });

  if (backgroundImage) {
    tl.to(backgroundImage, {
      xPercent: 0,
      opacity: 1,
      duration: 0.7,
    });
  }

  tl.to(
    gradientCircles,
    {
      xPercent: 0,
      stagger: 0.2,
      duration: 0.7,
      delay: backgroundImage ? 0.7 : 0.4,
    },
    '<',
  );

  tl.to(content, {opacity: 1, duration: 0.7});
};

// track if global events are already handled to not add another listeners on swup page reload
window.initSlidersHandled = window.initSlidersHandled || false;
window.contentShowHandled = window.contentShowHandled || false;

if (!window.disclaimer || !window.disclaimer.getIsContentHidden()) {
  initSliders();
  if (!window.initSlidersHandled) {
    document.addEventListener('swup:pageView', initSliders);
    window.initSlidersHandled = true;
  }
} else {
  if (!window.contentShowHandled) {
    window.addEventListener('contentShow', initSliders);
    window.contentShowHandled = true;
  }
}
